/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Tab_ExpiredInputs */

const en_settings_billing_tab_expired = /** @type {(inputs: Settings_Billing_Tab_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expired`)
};

/**
* | output |
* | --- |
* | "Expired" |
*
* @param {Settings_Billing_Tab_ExpiredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_tab_expired = /** @type {((inputs?: Settings_Billing_Tab_ExpiredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Tab_ExpiredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_tab_expired(inputs)
});
export { settings_billing_tab_expired as "settings.billing.tab_expired" }